module.exports = __webpack_public_path__ + "static/img/dxgc_3@2x.ff761ba3.png";